export default __webpack_public_path__ + "static/media/logoGreen.e9abb33a.svg";